/* eslint-disable import/first */
import React from 'react';

/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import ClassNames from 'classnames';
import { selectDesktop } from 'spwa-ui-library/esm/redux/store/appSlice';

import ViewCartButton from './ViewCartButton';
import CartItemCount from './CartItemCount';
import css from './index.module.scss';

const { selectProductBaseURL, selectCountryValidations } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;

const { cartItems } = Slices.cartSlice;

function CartBar({
  validate,
  miniCart,
  buttonText,
  to,
  onClick,
  reviewCart,
  reviewPopUp,
  setReviewPopUp,
  amtAlert,
  setAmtAlert,
  hideInfo = false,
  hideImg,
}) {
  const isDesktop = useSelector(selectDesktop);
  const cartState = useSelector((state) => state.cart);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const currency = countryValidations && countryValidations.currency;
  const baseUrl = useSelector(selectProductBaseURL);
  const cartItemList = useSelector(cartItems);
  if (!cartState.data.items.length) return '';
  const thumb = `${baseUrl}${cartState.data.items[0].imageThumbnail}`;

  const countOfItems = cartItemList.reduce((a, { qty }) => a + qty, 0);
  // console.log(countOfItems, 'countrtt');
  return (
    <div className={ClassNames(css.root, { [css.miniViewCart]: miniCart })}>
      {!miniCart && isDesktop && <CartItemCount src={thumb} count={countOfItems || 0} />}
      <ViewCartButton
        reviewCart={reviewCart}
        reviewPopUp={reviewPopUp}
        setReviewPopUp={setReviewPopUp}
        validate={validate}
        buttonText={buttonText}
        to={to}
        onClick={onClick}
        amount={cartState.cartValue || 0}
        currency={currency}
        cart={cartState}
        amtAlert={amtAlert}
        setAmtAlert={setAmtAlert}
        hideInfo={hideInfo}
        hideImg={hideImg}
      />
    </div>
  );
}
export default CartBar;
